/*
 * @Author: Src
 * @Date: 2025-07-23 18:33:05
 * @LastEditTime: 2025-08-12 15:24:18
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/carRouter/carAuditRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import AuditList from '@/views/carModule/auditsManagement/allAudits.vue';
import CarAuditList from '@/views/carModule/auditsManagement/carAuditList.vue';
import AuditDetail from '@/views/audit/AuditDetail.vue';
import TaskDetail from '@/views/audit/TaskDetail.vue';
import { AuthEnum } from '@/services/permission.service';


const carAuditRoutes: RouteConfig = {
  path: '/caraudit',
  component: Main,
  redirect: {
    name: 'caraudit.index',
  },
  meta: {
    title: '审核管理',
  },
  children: [
    {
      name: 'caraudit.index',
      path: '/caraudit/list',
      component: AuditList,
      props: {
        auth: [AuthEnum.二手车全部审核列表],
      },
      meta: {
        title: '审核列表',
      },
    },
    {
      name: 'caraudit.carlist',
      path: '/caraudit/carlist',
      component: CarAuditList,
      props: {
        auth: [AuthEnum.二手车待审核列表],
      },
      meta: {
        title: '待审核列表',
      },
    },
    {
      name: 'caraudit.detail',
      path: '/caraudit/detail/:id',
      component: AuditDetail,
      props: {
        auth: [AuthEnum.二手车全部审核列表, AuthEnum.二手车待审核列表],
      },
      meta: {
        title: '审核详情',
      },
    },
    {
      name: 'caraudit.taskdetail',
      path: '/caraudit/taskdetail/:id',
      component: TaskDetail,
      props: {
        auth: [AuthEnum.二手车全部审核列表, AuthEnum.二手车待审核列表],
      },
      meta: {
        title: '审核详情',
      },
    },
  ],

};

export default carAuditRoutes;
